import { useContext } from 'react';

import { TimeseriesChartIdContext } from '../context/TimeseriesChartId.context.js';

export const useTimeseriesChartId = () => {
  const id = useContext(TimeseriesChartIdContext);

  if (id === undefined) {
    throw new Error(
      'useTimeseriesChartId hook must be used within the TimeseriesChartIdContext',
    );
  }

  return id;
};
